import React from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const userLang = navigator.language || navigator.userLanguage;

const RejectModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  reason, 
  onReasonChange, 
  isLoading 
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={userLang === 'zh-CN' ? '拒绝退货申请' : 'Reject Return Request'}
    >
      <div className="p-6">
        <div className="mb-4">
          <p className="mb-4 text-gray-700">
            {userLang === 'zh-CN' 
              ? '警告：一旦拒绝退货，此操作不可撤销。客户将收到退货被拒绝的通知。' 
              : 'Warning: Once you reject a return, this action cannot be undone. The customer will be notified that their return request was rejected.'}
          </p>
          <label htmlFor="rejection-reason" className="block text-sm font-medium text-gray-700 mb-1">
            {userLang === 'zh-CN' ? '拒绝原因' : 'Reason for Rejection'}
          </label>
          <textarea
            id="rejection-reason"
            rows="4"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder={userLang === 'zh-CN' ? '请提供拒绝此退货申请的原因...' : 'Please provide a reason for rejecting this return request...'}
            value={reason}
            onChange={onReasonChange}
            disabled={isLoading}
          />
        </div>
        <div className="flex justify-end space-x-4">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {userLang === 'zh-CN' ? '取消' : 'Cancel'}
          </Button>
          <Button 
            variant="primary" 
            onClick={onSubmit} 
            disabled={isLoading}
            isLoading={isLoading}
          >
            {userLang === 'zh-CN' ? '确认拒绝' : 'Confirm Rejection'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectModal; 